import React from 'react'
import HeatMap from "react-heatmap-grid";
import Text from '../../genericComponents/Text';
import jetColors from "../../../assets/jetColors.json";
import styled from 'styled-components';
import colorScale from '../../../assets/images/escaladecoloresjet.svg'
import aimg from '../../../assets/images/a.png'
import bimg from '../../../assets/images/b.png'
import cimg from '../../../assets/images/c.png'
import dimg from '../../../assets/images/d.png'

export default React.memo(function MyComponent({simulationData,t,lengthPoints=4,printing}) {
  const xSpeakers = simulationData.SPx?.slice(1,-1);
  const ySpeakers = simulationData.SPy?.slice(1,-1);
  const pwidth = Math.round(simulationData.pointsNumx*(printing?0.33333:1))*lengthPoints;
  const pheight = Math.round(simulationData.pointsNumy*(printing?0.33333:1))*lengthPoints;
  const pixelFactor = pwidth/simulationData.length;
  const spdiameter = simulationData.D*pixelFactor;
  let spPointDiameter = simulationData.speakerNumt<50?14:(-0.08*simulationData.speakerNumt)+16;
  spPointDiameter = simulationData.speakerNumt>150?5:spPointDiameter
  const jetColorHeigth = simulationData.pointsNumy<75?300:pheight;
  const lastxspeakerpoint= xSpeakers[xSpeakers.length-1]*pixelFactor;
  const lastyspeakerpoint = ySpeakers[ySpeakers.length-1]*pixelFactor;
  const firstxspeakerpoint = xSpeakers[0]*pixelFactor;
  const firstyspeakerpoint = ySpeakers[0]*pixelFactor;

  return (
    <MaxContainer>
      <MyHeatMapContainer 
        width={pwidth}
        filas={simulationData.pointsNumy*(printing?1:1.2)} 
        columnas={simulationData.pointsNumx*(printing?1:1.2)}
        marginTop={simulationData.pointsNumy<75?(90-simulationData.pointsNumy)*1.6:20}
      >
        <Text id={'rotetedtext'} titleSize={1}  titleLevel={4}>{t('width_m')}</Text>
        
        <HeatMap
          xLabels={printing?simulationData.xLabelsforPrint:simulationData.xLabels}
          yLabels={printing?simulationData.yLabelsforPrint:simulationData.yLabels}
          xLabelWidth={0}
          xLabelsVisibility={Array(simulationData.pointsNumx).fill(0).map((r,i)=>i%(simulationData.defaultLength*(printing?0.025:0.1))?false:true)}
          xLabelsLocation={"bottom"}
          data={printing?simulationData.soundPressureforPrint:simulationData.soundPressure}
          squares
          height={lengthPoints}
          cellStyle={(_, value) => {
            const jetIndex =  Number.parseInt((120 - value) / (120 - 60)*720);
            const rgb = jetColors[jetIndex];
            return({
              background: `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 1)`,
              fontSize: "11.5px",
              margin:"0",
            })
          }}
        />
        <Text titleSize={1} id={'verticaltext'}  titleLevel={4}>{t('length_m')}</Text>
        <SpeakerMask pwidth={pwidth} pheight={pheight}>
          {ySpeakers?.map((xsp,i1)=>
            xSpeakers?.map((ysp,i2)=> 
              <SpeakerSubMask key={i1+i2+''} top={xsp*pixelFactor} left={ysp*pixelFactor} diameter={spdiameter}/>
            )
          )}
        </SpeakerMask>
        {printing&&(
          <SpeakerMask style={{overflow:'visible'}} pwidth={pwidth} pheight={pheight}>
            <VerticalLine left={0} top={-40} height={pheight+40}/>
            <VerticalLine left={firstxspeakerpoint} top={-40} height={pheight+40}/>
            <Vowel src={aimg} printing={printing} left={(firstxspeakerpoint*0.5)-(printing?8:12)} top={-30}/>

            <HorizontalLine top={0} left={0} width={pwidth+30}/>
            <HorizontalLine top={ySpeakers[0]*pixelFactor} left={-0} width={pwidth+30}/>
            <Vowel src={bimg} printing={printing} top={(ySpeakers[0]*pixelFactor*0.5)-(printing?8:12)} right={-28}/>

            <VerticalLine left={lastxspeakerpoint} top={-40} height={pheight+40}/>
            <VerticalLine left={pwidth-1} top={-40} height={pheight+40}/>
            <Vowel src={aimg} printing={printing} right={(firstxspeakerpoint*0.5)-(printing?8:12)} top={-30}/>

            <HorizontalLine top={lastyspeakerpoint} left={0} width={pwidth+30}/>
            <HorizontalLine top={pheight-2} left={0} width={pwidth+30}/>
            <Vowel src={bimg} printing={printing} top={(lastyspeakerpoint)-(printing?8:12)+(pheight-(lastyspeakerpoint))*0.5} right={-28}/>

            {xSpeakers.length>1&&(
              <Vowel src={cimg} printing={printing} top={firstyspeakerpoint-(printing?8:12)} left={(((xSpeakers[1]*pixelFactor)-firstxspeakerpoint)*0.5)-12+firstxspeakerpoint}/>
            )}
            
            {ySpeakers.length>1&&(
              <Vowel src={dimg} printing={printing} left={lastxspeakerpoint-(printing?8:12)} top={(((ySpeakers[1]*pixelFactor)-firstyspeakerpoint)*0.5)-12+firstyspeakerpoint}/>
            )}
            
          </SpeakerMask>
        )}
        <SpeakerMask pwidth={pwidth} pheight={pheight}>
          {ySpeakers?.map((xsp,i1)=>
            xSpeakers?.map((ysp,i2)=> 
              <SpeakerPoint key={i1+i2+'1'} top={xsp*pixelFactor} left={ysp*pixelFactor} spPointDiameter={spPointDiameter}/>
            )
          )}
        </SpeakerMask>
        
      </MyHeatMapContainer>
      <JetColorLimitsContainer printing={printing}>
        dB
        <img src={colorScale} alt="" style={{width:((jetColorHeigth-20)*0.04),height:jetColorHeigth-20}}/>
        <NumbersColorScale style={{height:jetColorHeigth}}>
          <Text titleSize={1}>120</Text>
          <Text titleSize={1}>108</Text>
          <Text titleSize={1}>96</Text>
          <Text titleSize={1}>84</Text>
          <Text titleSize={1}>72</Text>
          <Text titleSize={1}>60</Text>
        </NumbersColorScale>
      </JetColorLimitsContainer>
    </MaxContainer>
    
  );
},);

const VerticalLine = styled.div`
  background-color: #CCC;
  width: 1px;
  position: absolute;
  left: ${p=>p.left}px;
  top: ${p=>p.top}px;
  height: ${p=>p.height}px;
`;
const HorizontalLine = styled.div`
  background-color: #CCC;
  height: 1px;
  position: absolute;
  top: ${p=>p.top}px;
  width: ${p=>p.width}px;
  left: ${p=>p.left}px;
  right: ${p=>p.right}px;
`;
const Vowel = styled.img`
  width: ${p=>p.printing?16:24}px;
  height: ${p=>p.printing?16:24}px;
  position: absolute;
  top: ${p=>p.top}px;
  left: ${p=>p.left}px;
  bottom: ${p=>p.bottom}px;
  right: ${p=>p.right}px;
`;
const MaxContainer = styled.div`
  display: flex;
  width: 100%;
  flex:1;
  flex-direction: row;
  /* align-items: center; */
  justify-content: flex-start;
`;
const MyHeatMapContainer = styled.div`
  position: relative;
  width: ${p=>p.width+80}px;
  padding-left: 20px;
  margin-top: ${p=>p.marginTop||'20'}px;
  #rotetedtext{
    position: absolute;
    transform-origin: 0 0;
    transform: rotate(-90deg) translateY(-20px) ${p=>'translateX('+(p.filas*-1.5-35)+'px)'};
  }
  #verticaltext{
    margin-left: ${p=>p.columnas*1.5+10}px;
    margin-top:8px;
  }
`;
const SpeakerMask = styled.div`
  position:absolute;
  display:flex;
  height:${p=>p.pheight}px;
  width:${p=>p.pwidth}px;
  top:0;
  left:60px;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
`;
const SpeakerSubMask = styled.div`
  width: ${p=>p.diameter}px;
  height: ${p=>p.diameter}px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${p=>p.top}px;
  left: ${p=>p.left}px;
  border-radius: ${p=>p.diameter}px;
  border: 1px #CCC solid;
  transform: ${p=>{const radius=-p.diameter/2; return 'translateX('+radius+'px) translateY('+radius+'px)'}};
`;
const SpeakerPoint = styled.div`
  width: ${p=>p.spPointDiameter}px;
  height:${p=>p.spPointDiameter}px;
  border-radius: ${p=>p.spPointDiameter}px;
  background-color: #FFF;
  border: 1px #aaa solid;
  position: absolute;
  top: ${p=>p.top}px;
  left: ${p=>p.left}px;
  transform: ${p=>{const radius=-p.spPointDiameter/2; return 'translateX('+radius+'px) translateY('+radius+'px)'}};
`;
const JetColorLimitsContainer = styled.div`
  display:flex;
  flex:1;
  flex-direction:column;
  align-items:center;
  width: 50px;
  position: relative;
  height: fit-content;
  margin-top: 16px;
  margin-left: ${p=>p.printing?'16px':'0'};
  margin-right: 12px;
`;
const NumbersColorScale = styled.div`
  position:absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 60px;
  bottom:-10px;
`;